export default {
    send_email: "Invia Email",
    send: "Invia",
    close: "Chiudi",
    logout: "Esci",
    hello: "Hello",
    goodbye: "Goodbye",
    please: "Please",
    thankYou: "Thank you",
    yes: "Yes",
    no: "No",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    update: "Update",
    loading: "Loading",
    error: "Error",
    success: "Success",
    home: "Home",
    settings: "Settings",
    profile: "Profile",
    notifications: "Notifications",
    messages: "Messages",
    search: "Search",
    filter: "Filter",
    sort: "Sort",
    view: "View",
    more: "More",
    less: "Less",
    back: "Back",
    next: "Next",
    previous: "Previous",
    submit: "Submit",
    reset: "Reset",
    close: "Close",
    open: "Open",
    upload: "Upload",
    download: "Download",
    help: "Help",
    info: "Information",
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    aboutUs: "About Us",
    contactUs: "Contact Us",
    faq: "FAQ",
    language: "Language",
    theme: "Theme",
    darkMode: "Dark Mode",
    lightMode: "Light Mode",
    date: "Date",
    time: "Time",
    day: "Day",
    month: "Month",
    year: "Year",
    hour: "Hour",
    minute: "Minute",
    second: "Second",
    dashboard: "Dashboard",
    orders: "Orders",
    products: "Products",
    customers: "Customers",
    sales: "Sales",
    reports: "Reports",
    analytics: "Analytics",
    inventory: "Inventory",
    shipments: "Shipments",
    returns: "Returns",
    payment: "Payment",
    invoices: "Invoices",
    transaction: "Transaction",
    status: "Status",
    action: "Action",
    details: "Details",
    total: "Total",
    quantity: "Quantity",
    price: "Price",
    unit: "Unit",
    description: "Description",
    add: "Add",
    remove: "Remove",
    update: "Update",
    searchResults: "Search Results",
    noResultsFound: "No Results Found",
    filterBy: "Filter by",
    sortBy: "Sort by",
    viewDetails: "View Details",
    editItem: "Edit Item",
    deleteItem: "Delete Item",
    confirmDelete: "Are you sure you want to delete this item?",
    orderNumber: "Order Number",
    orderDate: "Order Date",
    deliveryDate: "Delivery Date",
    paymentStatus: "Payment Status",
    orderStatus: "Order Status",
    shippingAddress: "Shipping Address",
    billingAddress: "Billing Address",
    customerName: "Customer Name",
    contactNumber: "Contact Number",
    emailAddress: "Email Address",
    companyName: "Company Name",
    department: "Department",
    jobTitle: "Job Title",
    feedback: "Feedback",
    survey: "Survey",
    ratings: "Ratings",
    comments: "Comments",
    notes: "Notes",
    helpDesk: "Help Desk",
    liveChat: "Live Chat",
    supportTicket: "Support Ticket",
    knowledgeBase: "Knowledge Base",
    userGuide: "User Guide",
    documentation: "Documentation",
    training: "Training",
    tutorial: "Tutorial",
    webinar: "Webinar",
    event: "Event",
    announcement: "Announcement",
    reminder: "Reminder",
    alert: "Alert",
    warning: "Warning",
    subscription: "Subscription",
    membership: "Membership",
    plan: "Plan",
    upgrade: "Upgrade",
    renewal: "Renewal",
    cancellation: "Cancellation",
    refund: "Refund",
    credit: "Credit",
    balance: "Balance",
    paymentMethod: "Payment Method",
    cardNumber: "Card Number",
    expirationDate: "Expiration Date",
    cvv: "CVV",
    billingInformation: "Billing Information",
    shippingInformation: "Shipping Information",
    orderSummary: "Order Summary",
    customerSupport: "Customer Support",
    privacySettings: "Privacy Settings",
    accountSettings: "Account Settings",
    generalSettings: "General Settings",
    systemSettings: "System Settings",
    userManagement: "User Management",
    accessControl: "Access Control",
    permissions: "Permissions",
    roles: "Roles",
    auditLog: "Audit Log",
    backup: "Backup",
    restore: "Restore",
    maintenance: "Maintenance",
    updateAvailable: "Update Available",
    version: "Version",
    releaseNotes: "Release Notes",
    changelog: "Changelog",
    user: "User",
    users: "Users",
    login: "Login",
    logout: "Logout",
    profile: "Profile",
    changePassword: "Change Password",
    password: "Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    forgotPassword: "Forgot Password?",
    resetPassword: "Reset Password",
    sendPasswordResetLink: "Send Password Reset Link",
    passwordReset: "Password Reset",
    export: "Export",
    import: "Import",
    share: "Share",
    upload: "Upload",
    download: "Download",
    downloadTemplate: "Download Template",
    uploadFile: "Upload File",
    uploadFiles: "Upload Files",
    downloadFiles: "Download Files",
    options: "Options",
    dataNotFound: "Data Not Found",
    reload: "Reload",
    totals: "Totals",
    block_maiusc_active: "Block Maiusc Active",
    logout: "Logout"
}
